import React, { Component } from 'react';
import { GenericEditPanel, GenericSelect, GenericOption } from 'com-gyf-webcore-userinterfacecomponents';
let DateTimeField = require('react-bootstrap-datetimepicker');
import GlobalHelper from '../../../../Common/Helpers/GlobalHelper';

class FechaTopeAgro extends Component {
    constructor(props) {
        super(props);

        this.actualizarNovedadEstado = this.actualizarNovedadEstado.bind(this);
        this.changeDate = this.changeDate.bind(this);
    }
    /**
     * 
     * @param {any} novedad
     * @param {any} estadoId
     * @param {any} entidadId
     */
    actualizarNovedadEstado(novedad, estadoId, entidadId) {
        this.props.actualizarNovedadEstado(novedad.Id, estadoId, this.props.codigoNovedad, novedad.NovedadTipoId, entidadId)
    }
    /**
     * 
     * @param {any} date
     */
    changeDate(date) {
        if (date != "Invalid date") {
            let dateParts = date.split("/");
            let newDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
            this.props.changeDate(0, this.props.codigoNovedad, date != "" ? newDate.toISOString().slice(0, 19).replace('T', ' ') : "");
        }
        else {
            this.props.changeDataError(this.props.codigoNovedad);
        }
    }
    /**
     * 
     */
    render() {
        const { props } = this;
        const error = (props.data.dataPickerError == true && props.codigoNovedad == props.data.componenteSeleccionado);
        const errorDataPicker = error ? <label className="error">Debe seleccionar una fecha válida y/o posterior al dia de la fecha.</label> : null

        //////////Novedad en Fecha Tope Agro////////////
        let seEstaEditando = props.data.seEstaEditando;
        let fecha = undefined;
        let fechaFormato = undefined;
        let defaultText = undefined;
        let novedadFechaTopeAgro = undefined;
        if (props.data.novedadesEmpresaDatos != undefined) {
            novedadFechaTopeAgro = props.data.novedadesEmpresaDatos.find(x => x.NovedadCampoCodigo == props.codigoNovedad);
            if (novedadFechaTopeAgro != undefined) {
                let esNovedadEditadaFechaTopeAgro = props.data.esNovedadEditada.find(x => x.campoCodigo == props.codigoNovedad).editado;
                novedadFechaTopeAgro.ValorAnterior = novedadFechaTopeAgro.ValorAnterior != null ? novedadFechaTopeAgro.ValorAnterior : "Sin vigencia definida";
                if (esNovedadEditadaFechaTopeAgro) {
                    fecha = props.data.empresaDatos.FechaTopeAgro;
                    if (fecha != null && fecha != "") {
                        fechaFormato = defaultText = GlobalHelper.FormatDate(fecha);
                    } else {
                        defaultText = "Seleccione una fecha";
                        fechaFormato = GlobalHelper.FormatDate(new Date().toISOString().slice(0, 19).replace('T', ' '));
                    }
                }
                else {
                    fecha = novedadFechaTopeAgro.ValorNovedad;
                    if (fecha != null && fecha != "") {
                        fechaFormato = defaultText = GlobalHelper.FormatDate(fecha);
                    } else {
                        defaultText = "Seleccione una fecha";
                        fechaFormato = GlobalHelper.FormatDate(new Date().toISOString().slice(0, 19).replace('T', ' '));
                    }
                }
            }
            else {
                fecha = props.data.empresaDatos.FechaTopeAgro;
                if (fecha != null && fecha != "") {
                    fechaFormato = defaultText = GlobalHelper.FormatDate(fecha);
                } else {
                    defaultText = "Seleccione una fecha";
                    fechaFormato = GlobalHelper.FormatDate(new Date().toISOString().slice(0, 19).replace('T', ' '));
                }
            }
        } else {
            fecha = props.data.empresaDatos.FechaTopeAgro;
            if (fecha != null && fecha != "") {
                fechaFormato = defaultText = GlobalHelper.FormatDate(fecha);
            } else {
                defaultText = "Seleccione una fecha";
                fechaFormato = GlobalHelper.FormatDate(new Date().toISOString().slice(0, 19).replace('T', ' '));
            }
        }
        ////////////////////////////////////////////////////


        let componenteFechaTopeAgro = (
            <DateTimeField
                mode="date"
                defaultText={defaultText}
                dateTime={fechaFormato}
                format={"DD/MM/YYYY"}
                inputFormat={"DD/MM/YYYY"}
                onChange={this.changeDate} />
        );

        return (
            <div>
                <GenericEditPanel
                    componente={componenteFechaTopeAgro}
                    error={error}
                    novedad={novedadFechaTopeAgro}
                    permisoUsuario={props.data.funcionesDelUsuario}
                    seEstaEditando={seEstaEditando}
                    textPanel={fechaFormato || "Sin especificar"}
                    title="Fecha tope Agro"
                    value={fechaFormato}

                    aceptChanges={(value) => props.guardarNovedad(value)}
                    confirmarNovedad={() => this.actualizarNovedadEstado(novedadFechaTopeAgro, 2, props.data.empresaDatos.Id)}
                    changeEditMode={(value) => props.estadoEdicion(value, props.codigoNovedad)}
                    denegarNovedad={() => this.actualizarNovedadEstado(novedadFechaTopeAgro, 3, props.data.empresaDatos.Id)}
                    mostrarModificaciones={props.mostrarModal}
                    revert={props.cancelar} />
                {errorDataPicker}
            </div>
        );
    }
}

export default FechaTopeAgro;